import axios from 'axios';
import Cookies from 'universal-cookie';
import config from '../../config';

const cookies = new Cookies();

const apiClient = typeof axios.create === 'function'
  ? axios.create({
    baseURL: config.API_BASE_URL,
  })
  : axios;

if (apiClient.interceptors?.request?.use) {
  apiClient.interceptors.request.use((requestConfig) => {
    const token = cookies.get('TOKEN');

    if (token) {
      requestConfig.headers = requestConfig.headers || {};
      requestConfig.headers.Authorization = `Bearer ${token}`;
    }

    return requestConfig;
  });
}

export default apiClient;
